module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-10-001fdfeda990e028fc5cc9b36088fa6d.png";